import { render } from "./ThumbDetailView.vue?vue&type=template&id=0fd417f9&scoped=true"
import script from "./ThumbDetailView.vue?vue&type=script&lang=js"
export * from "./ThumbDetailView.vue?vue&type=script&lang=js"

import "./ThumbDetailView.vue?vue&type=style&index=0&id=0fd417f9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fd417f9"]])

export default __exports__